<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `transaction/event-detail/${inputs.id}`
						: `transaction/event-detail`
				"
			>
				<div class="form-group row align-items-center" v-if="!selectedUrl">
					<label for="inputs_event_id" class="col-sm-3 mb-0">
						Event
					</label>
					<app-input
						id="inputs_event_id"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.event_id"
						:list="eventIdLists"
						:required="true"
						:placeholder="'Select Event'"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_date" class="col-sm-3 mb-0">
						Date
					</label>
					<app-input
						id="inputs_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.date"
						:required="true"
						:placeholder="'Date'"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label
						for="inputs_time_start_formatted"
						class="col-sm-3 mb-0"
					>
						Start Time
					</label>
					<app-input
						id="inputs_time_start_formatted"
						class="col-sm-9"
						type="time"
						v-model="inputs.time_start_formatted"
						:required="true"
						:placeholder="'Start Time'"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label
						for="inputs_time_end_formatted"
						class="col-sm-3 mb-0"
					>
						End Time
					</label>
					<app-input
						id="inputs_time_end_formatted"
						class="col-sm-9"
						type="time"
						v-model="inputs.time_end_formatted"
						:required="true"
						:placeholder="'End Time'"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_location" class="col-sm-3 mb-0">
						Location
					</label>
					<app-input
						id="inputs_location"
						class="col-sm-9"
						type="text"
						v-model="inputs.location"
						:required="true"
						:placeholder="'Location'"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";

export default {
	name: "EventRegistrationDetailTableForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
	},
	data() {
		return {
			preloader: false,
			inputs: {},
			eventIdLists: [],
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}

		this.fetchData();
	},
	methods: {
		async fetchData() {
			try {
				let eventIdResponse = await axios.get(
					"/transaction/event?per_page=500"
				);
				eventIdResponse.data.data.forEach((item) => {
					this.eventIdLists.push({
						id: item.id,
						value: item.name,
					});
				});
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		submit() {
			let submittedData = {
				date: this.formattedDate(this.inputs.date),
				time_start: this.inputs.time_start_formatted,
				time_end: this.inputs.time_end_formatted,
				location: this.inputs.location,
			};
			if (!this.selectedUrl) {
				submittedData.event_id = this.inputs.event_id;
				submittedData.time_start = this.inputs.time_start_formatted + ":00";
				submittedData.time_end = this.inputs.time_end_formatted + ":00";
			}
			this.save(submittedData);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.preloader = false;
		},
		formattedDate(payloadDate) {
			const originalDate = payloadDate;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day}`;

			return formattedDate;
		},
	},
};
</script>
